"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let Account = class Account extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    ownerId;
    onOwner_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("ownerId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    item;
    async $$load_item() {
        return this.oid == null
            ? this.$fn.schemaDefaults('CreateAccount', { owner: { id: this.ownerId } })
            : this.$fn.fetch('read_account', { asResource: true, parameters: { id: this.oid } });
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['formId', 'item', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                item: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "lg",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.oid == null ?
                    this.$fn.gettext("New Cash or Bank Account") :
                    [this.item.snapshot("name"), this.$fn.gettext("Account")],
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_1794_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async evh_8564662037462133_reload(event, scope) {
        return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
    }
    async act_8564662037462133_reloadSlickgrid_1802_getActionArgs($event) {
        return {
            grid: "payments",
        };
    }
    async evh_8564662037462133_deleted(event, scope) {
        return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_setData_1806_getActionArgs($event) {
        return {
            path: "item",
            value: $event.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_1040167445267876_setData_1806_getWhen($event) {
        return !!$event.data;
    }
    async act_1040167445267876_emit_1808_getActionArgs($event) {
        return {
            event: "saved",
            value: $event.data,
        };
    }
    async act_1040167445267876_closeModal_1810_getActionArgs($event) {
        return {
            result: {
                ok: true,
                value: $event.data,
            },
        };
    }
    async act_1040167445267876_reloadSlickgrid_1812_getActionArgs($event) {
        return {
            grid: "accounts",
        };
    }
    async act_1040167445267876_crud_1804_getActionArgs($event) {
        return {
            objectType: "account",
            op: "upsert",
            data: this.item,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    async act_7789867021953041_reloadSlickgrid_1816_getActionArgs($event) {
        return {
            grid: "accounts",
        };
    }
    async evh_7789867021953041_saved(event, scope) {
        return await this.actions.evh_7789867021953041_saved.executeFromDOM(this, event, scope);
    }
    async act_1419464017721962_closeModal_1818_getActionArgs($event) {
        return {
            result: {
                close: true,
            },
        };
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_1794 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_1794_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_1793 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_1794,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_1793],
        });
        const act_2248226175642056_closeModal_1796 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_1795 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_1796,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_1795],
        });
        const act_8564662037462133_reloadComponentData_1798 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8564662037462133_reload_1797 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadComponentData_1798,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_8564662037462133_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_reload_1797],
        });
        const act_8564662037462133_closeComponent_1800 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_8564662037462133_deleted_1799 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_closeComponent_1800,
            event: "deleted",
            displayName: "closeComponent",
        });
        const act_8564662037462133_reloadSlickgrid_1802 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8564662037462133_reloadSlickgrid_1802_getActionArgs,
            events: [],
        });
        const evh_8564662037462133_deleted_1801 = new core_1.actions.EventHandlerImpl({
            action: act_8564662037462133_reloadSlickgrid_1802,
            event: "deleted",
            displayName: "reloadSlickgrid",
        });
        const evh_8564662037462133_deleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8564662037462133_deleted_1799, evh_8564662037462133_deleted_1801],
        });
        const act_1040167445267876_setData_1806 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1040167445267876_setData_1806_getActionArgs,
            when: this.act_1040167445267876_setData_1806_getWhen,
            events: [],
        });
        const evh_1040167445267876_success_1805 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_setData_1806,
            event: "success",
            displayName: "setData",
        });
        const act_1040167445267876_emit_1808 = new core_1.actions.EmitAction({
            actionArgs: this.act_1040167445267876_emit_1808_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_1807 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_emit_1808,
            event: "success",
            displayName: "emit",
        });
        const act_1040167445267876_closeModal_1810 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1040167445267876_closeModal_1810_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_1809 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_closeModal_1810,
            event: "success",
            displayName: "closeModal",
        });
        const act_1040167445267876_reloadSlickgrid_1812 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1040167445267876_reloadSlickgrid_1812_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_1811 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_reloadSlickgrid_1812,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_1040167445267876_crud_1804 = new core_1.actions.CRUDAction({
            actionArgs: this.act_1040167445267876_crud_1804_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_1805, evh_1040167445267876_success_1807, evh_1040167445267876_success_1809, evh_1040167445267876_success_1811],
        });
        const evh_1040167445267876_submit_1803 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_crud_1804,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_1803],
        });
        const act_7789867021953041_closeModal_1814 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_7789867021953041_saved_1813 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_closeModal_1814,
            event: "saved",
            displayName: "closeModal",
        });
        const act_7789867021953041_reloadSlickgrid_1816 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_7789867021953041_reloadSlickgrid_1816_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_saved_1815 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_reloadSlickgrid_1816,
            event: "saved",
            displayName: "reloadSlickgrid",
        });
        const evh_7789867021953041_saved = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7789867021953041_saved_1813, evh_7789867021953041_saved_1815],
        });
        const act_1419464017721962_closeModal_1818 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_1419464017721962_closeModal_1818_getActionArgs,
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_1817 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_1818,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_1817],
        });
        return {
            act_7315092382398562_closeModal_1794,
            evh_7315092382398562_close_1793,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_1796,
            evh_2248226175642056_close_1795,
            evh_2248226175642056_close,
            act_8564662037462133_reloadComponentData_1798,
            evh_8564662037462133_reload_1797,
            evh_8564662037462133_reload,
            act_8564662037462133_closeComponent_1800,
            evh_8564662037462133_deleted_1799,
            act_8564662037462133_reloadSlickgrid_1802,
            evh_8564662037462133_deleted_1801,
            evh_8564662037462133_deleted,
            act_1040167445267876_setData_1806,
            evh_1040167445267876_success_1805,
            act_1040167445267876_emit_1808,
            evh_1040167445267876_success_1807,
            act_1040167445267876_closeModal_1810,
            evh_1040167445267876_success_1809,
            act_1040167445267876_reloadSlickgrid_1812,
            evh_1040167445267876_success_1811,
            act_1040167445267876_crud_1804,
            evh_1040167445267876_submit_1803,
            evh_1040167445267876_submit,
            act_7789867021953041_closeModal_1814,
            evh_7789867021953041_saved_1813,
            act_7789867021953041_reloadSlickgrid_1816,
            evh_7789867021953041_saved_1815,
            evh_7789867021953041_saved,
            act_1419464017721962_closeModal_1818,
            evh_1419464017721962_clickPreventStop_1817,
            evh_1419464017721962_clickPreventStop,
            save: act_1040167445267876_crud_1804,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], Account.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Account.prototype, "onOid", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: null,
    }),
    __metadata("design:type", String)
], Account.prototype, "ownerId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('ownerId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Account.prototype, "onOwner_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "lg",
    }),
    __metadata("design:type", String)
], Account.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Account.prototype, "onSize", null);
Account = __decorate([
    (0, vue_property_decorator_1.Component)()
], Account);
exports.default = Account;
vue_property_decorator_1.Vue.component("Account", Account);
